export const formatDate = (isoDate: Date | string | undefined) => {
  if (!isoDate) {
    return ''
  }

  const dateObj = new Date(isoDate)

  const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' } as const

  // formatToParts(...) method returns an array of objects from which only several are necessary to create the formatted dateTime string
  // in order to skip the unnecessary objects, double commas (,,) are used
  const [
    { value: day },,
    { value: month },,
    { value: year },,
    { value: hour },,
    { value: minute },,
    { value: timeZoneName }
  ] = new Intl.DateTimeFormat('en-GB', options).formatToParts(dateObj)

  return `${day}.${month}.${year}, ${hour}:${minute} ${timeZoneName}`
}

export const formatTime = (isoDate: Date | string | undefined): string => {
  if (!isoDate) {
    return ''
  }

  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' }).format(new Date(isoDate))
    .replace(',', '')
}
